import { ApiPointListRepository } from '@/models/point/list/point-list-repository'
import { PointService } from '@/services/point'
import { ContactOnMyPageContext } from '@spa/components/organisms/contact/model/context/contact-on-my-page/contact-on-my-page-context'
import ForgotPassword from '@spa/components/pages/auth/reset/ForgotPassword.vue'
import Inquiry from '@spa/components/pages/inquiry/Inquiry.vue'
import ChangeMailMagazine from '@spa/components/pages/mypage/edit/ChangeMailMagazine.vue'
import MyPageEditPassword from '@spa/components/pages/mypage/edit/ChangePassword.vue'
import MyPageEditEachContact from '@spa/components/pages/mypage/edit/contact/Contact.vue'
import MyPageEditContact from '@spa/components/pages/mypage/edit/contact/Index.vue'
import MyPageEditNewContact from '@spa/components/pages/mypage/edit/contact/NewContact.vue'
import MyPageEditProfile from '@spa/components/pages/mypage/edit/UpdateProfile.vue'
import MyPageOrderHistory from '@spa/components/pages/mypage/order/History.vue'
import MyPageOrderHistoryDetail from '@spa/components/pages/mypage/order/HistoryDetail.vue'
import MyPageOrderHistoryDetailCancel from '@spa/components/pages/mypage/order/HistoryDetailCancel.vue'
import MyPageOrderHistoryDetailCanceled from '@spa/components/pages/mypage/order/HistoryDetailCanceled.vue'
import ReorderCreditcard from '@spa/components/pages/mypage/order/reorder/ReorderCreditcard.vue'
import ReorderProfile from '@spa/components/pages/mypage/order/reorder/ReorderProfile.vue'
import Point from '@spa/components/pages/mypage/point/Point.vue'
import NotFound from '@spa/hl-app/components/error/NotFound.vue'
import OpenExternalBrowser from '@spa/hl-app/components/OpenExternalBrowser.vue'
import PurchaseExecution from '@spa/hl-app/components/order/PurchaseExecution.vue'
import RegisterCreditCard from '@spa/hl-app/components/order/RegisterCreditCard.vue'
import Router from 'vue-router'

const router = new Router({
  mode: 'history',
  base: '/hlapp/direct',
  /**
   * /hlapp/direct 以降のパスは /s でのパスと対応していなければならない
   * SPA内部でのリンクは自身が /s か /hlapp/direct かで分岐させるような実装にはしていないため
   *
   * @see https://my-color.esa.io/posts/1362
   */
  routes: [
    {
      path: '/mypage/order',
      component: MyPageOrderHistory,
      meta: { requireLogin: true },
    },
    {
      path: '/mypage/order/:id',
      component: MyPageOrderHistoryDetail,
      meta: { requireLogin: true },
    },
    {
      path: '/mypage/order/:id/cancel',
      component: MyPageOrderHistoryDetailCancel,
      meta: { requireLogin: true },
    },
    {
      path: '/mypage/order/:id/canceled',
      component: MyPageOrderHistoryDetailCanceled,
      meta: { requireLogin: true },
    },
    {
      path: '/mypage/order/:id/reorder/creditcard',
      component: ReorderCreditcard,
      meta: { requireLogin: true },
    },
    // アプリWebViewではPayPayを開くことができないため、再注文画面は一律外部ブラウザで開く
    // その際に /hlapp/direct/ を /s/ に置き換える
    {
      path: '/mypage/order/:id/reorder/payment',
      component: OpenExternalBrowser,
      props: route => ({
        path: `/s${route.fullPath}`,
      }),
    },
    {
      path: '/mypage/order/:id/reorder/profile',
      component: ReorderProfile,
      meta: { requireLogin: true },
    },
    {
      path: '/mypage/edit/profile',
      component: MyPageEditProfile,
      meta: { requireLogin: true },
    },
    {
      path: '/mypage/edit/contact',
      component: MyPageEditContact,
      props: {
        context: ContactOnMyPageContext.build(),
      },
      meta: { requireLogin: true },
    },
    {
      path: '/mypage/edit/new-contact',
      component: MyPageEditNewContact,
      props: {
        context: ContactOnMyPageContext.build(),
      },
      meta: { requireLogin: true },
    },
    {
      path: '/mypage/edit/contact/:id',
      component: MyPageEditEachContact,
      props: {
        context: ContactOnMyPageContext.build(),
      },
      meta: { requireLogin: true },
    },
    {
      path: '/mypage/edit/mail-magazine',
      component: ChangeMailMagazine,
      meta: { requireLogin: true },
    },
    {
      path: '/mypage/edit/password',
      component: MyPageEditPassword,
      meta: { requireLogin: true },
    },
    {
      path: '/mypage/points',
      component: Point,
      meta: { requireLogin: true },
      props: () => ({
        listRepository: new ApiPointListRepository(PointService.createDefault()),
      }),
    },
    {
      path: '/forgot-password',
      component: ForgotPassword,
      meta: { allowGuest: true },
    },
    {
      path: '/inquiry',
      component: Inquiry,
      meta: { allowGuest: true },
    },
    // これ以降 /hlapp/direct 独自のパス
    {
      path: '/purchase-execution',
      component: PurchaseExecution,
      meta: { requireLogin: true },
    },
    {
      path: '/register-credit-card',
      component: RegisterCreditCard,
      meta: { requireLogin: true },
    },
    {
      path: '*',
      component: NotFound,
    },
  ],
  scrollBehavior(_to, _from, _savedPosition) {
    return { x: 0, y: 0 }
  },
})

export default router
